class ArrayService{
  constructor(){

  }

  /**
   * @INFO Barajar (Randomizar) un array
   * @param array
   * @returns
   */
  public shuffle(array: any[]) {
    let currentIndex = array.length,  randomIndex;
    while (currentIndex != 0) {
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex--;
      [array[currentIndex], array[randomIndex]] = [
      array[randomIndex], array[currentIndex]];
    }
    return array;
  }

}

export default ArrayService;
